module.exports = __webpack_public_path__ + "img/googlePlayBadge.100dc9cc.svg";